module.exports = __webpack_public_path__ + "static/media/Reman_Animation_System.be0835b3.gif";